<mat-card [@flipInY]="animationState" class="dashboard-card">
  <div *ngIf="showSummary">
    <div class="fieldRow">
      <div>
        <button mat-mini-fab color="primary" aria-label="Refresh">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
      <div>
        <button mat-mini-fab color="primary" aria-label="Refresh"
                matTooltip="Gateway Delay Analysis focusses on messages that in the GatewayTran table that have not yet had a TranLog message added, which implies the messages are either queued or not going out.">
          <mat-icon>info</mat-icon>
        </button>
      </div>
      <div>
        <button mat-mini-fab color="primary" (click)="filterResults()" aria-label="Filter">
          <mat-icon>tune</mat-icon>
        </button>
      </div>
      <div>
        <h3>Gateway Delay Analysis</h3>
      </div>
    </div>
    <table *ngIf="tempSummary | async; else loading" mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="OwnerID">
        <th mat-header-cell *matHeaderCellDef> UID </th>
        <td mat-cell *matCellDef="let element"><div [matTooltip]="userDetails(element)">{{element.OwnerId}}</div></td>
      </ng-container>

      <ng-container matColumnDef="When">
        <th mat-header-cell *matHeaderCellDef> Created </th>
        <td mat-cell *matCellDef="let element"> {{element.When  | date:'short' : '' : translate.currentLang}} </td>
      </ng-container>

      <ng-container matColumnDef="SurveyDescription">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element"> {{element.Survey.Description}} </td>
      </ng-container>

      <ng-container matColumnDef="Count">
        <th mat-header-cell *matHeaderCellDef> Messages Delayed </th>
        <td mat-cell *matCellDef="let element"> {{element.Count}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row class="users-element-row" *matRowDef="let row; columns: displayedColumns;" (click)="edit(row)"></tr>
    </table>
  </div>
  <div *ngIf="!showSummary">
    <div class="fieldRow">
      <div>
        <button mat-mini-fab color="primary" (click)="noSave()" aria-label="Back">
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
      <div>
        <button mat-mini-fab color="primary" aria-label="Save">
          <mat-icon>save</mat-icon>
        </button>
      </div>
    </div>
    <div>
      <div>
        <h3>Gateway Delay Analysis</h3>
        <p>
          Gateway Delay Analysis focusses on messages that in the GatewayTran table that have not yet had a TranLog message added, which implies the messages are either queued or not going out.
        </p>
      </div>
    </div>
    <div>
    </div>
  </div>
  <ng-template #userProfileTemplate let-element>
  </ng-template>
  <ng-template #loading>
    <div class="loading-container">
      <span class="loading-content">
        <div class="spinner-div"><mat-spinner [diameter]="25"></mat-spinner></div>
        <div class="spinner-text"> Loading analysis...</div>
      </span>
    </div>
    <br /><br />
  </ng-template>
</mat-card>
